import React, { useEffect, useState } from "react";
import { Button } from "components/ui";

const PageHeader = ({ title, buttons = [], icon }) => {
  return (
    <div className="flex lg:flex-row flex-col lg:items-center lg:justify-between mb-5 gap-4">
      <div className="capitalize font-bold text-black md:text-2xl xs:text-base sm:text-xl flex">
        <span className="mr-1" style={{ marginTop: "2px" }}>
          {icon}
        </span>
        <span>{title}</span>
      </div>
      <div className="lg:flex grid grid-cols-3 gap-2">
        {buttons?.map((btn, index) => {
          const component = (
            <Button
              key={index}
              size="sm"
              variant={btn?.variant || "solid"}
              type={btn?.type || "button"}
              onClick={(e) => btn?.onClick?.(btn?.key, e)}
              className=" capitalize w-fit"
              icon={btn.icon}
              disabled={btn?.disabled}
              loading={btn?.loading}
            >
              {btn.label}
            </Button>
          );
          if (btn?.key) {
            return component;
          } else return component;
        })}
      </div>
    </div>
  );
};

export default PageHeader;
